import { BUILD_TIMESTAMP } from './timestamp';
import packageJson from '../../package.json';

export const environment = {
  appName: 'Lead Platform - Test',
  production: false,
  name: 'Test',
  baseUrl: 'https://lg-electronics-test.staging.emendis.nl/api',
  sentryUrl: 'https://b71a143b898f47bfbc9347b944bbbda2@o4504360297496576.ingest.sentry.io/4504377890308096',
  databaseName: 'lg.test',
  version: packageJson.version + '.' + BUILD_TIMESTAMP,
  redirectAfterLogin: '/',
  url: 'https://lg-electronics.test.emendis.nl',
  gtm: '',
  domainLanguages: {
    'lg-electronics.test.emendis.nl': 'nl',
    'lg-electronics-nl.test.emendis.nl': 'nl',
    'lg-electronics-el.test.emendis.nl': 'el',
    'lg-electronics-es.test.emendis.nl': 'es',
    'lg-electronics-en.test.emendis.nl': 'en',
    'lg-electronics-de.test.emendis.nl': 'de',
  },
};
